/**
 * 0.155 (ADR 0157): Signale der Werkzeuge auf der Projektübersicht – je Quelle eine optionale Karte. Jedes Signal nennt
 * Quelle, Anlass, Ziel, Zeitpunkt und (über `kind`/`id`) den Weg zum Inhalt. Dasselbe Objekt steht je Karte einmal mit
 * allen Gründen. Nur Sichtbares, gefiltert wie die Originale; kein Signal aus einem abgeschalteten Werkzeug.
 */
export const OVERVIEW_CARDS = ['schedule', 'budget', 'time', 'docs', 'goals', 'people'] as const;
export type OverviewCard = (typeof OVERVIEW_CARDS)[number];
/** Werkzeug, das eine Karte speist (Einsätze ergänzen die Termine, wenn „Einsätze“ zugeschaltet ist) */
export const OVERVIEW_CARD_TOOL: Record<OverviewCard, string> = { schedule: 'events', budget: 'budget', time: 'time', docs: 'docs', goals: 'goals', people: 'people' };

export type SignalReason =
  | 'today'
  | 'tomorrow'
  | 'openShifts'
  | 'openShift'
  | 'openCommitments'
  | 'overPlan'
  | 'costOpen'
  | 'missingRates'
  | 'reviewDue'
  | 'goalDue'
  | 'riskReview'
  | 'riskNoMeasure'
  | 'roleOpen';

export interface SignalItemDto {
  kind: 'event' | 'shift' | 'line' | 'report' | 'page' | 'goal' | 'risk' | 'role';
  id: string;
  title: string;
  /** maßgeblicher Tag (Termin, Prüfung, Fälligkeit) */
  day: string | null;
  /** Uhrzeit bei Terminen/Einsätzen mit Zeit */
  time: string | null;
  reasons: { reason: SignalReason; n?: number }[];
  /** Rollen: der Anlass, an dem die Rolle fehlt (Aufgabe oder Termin) – dorthin führt die Zeile */
  target?: { kind: 'task' | 'event'; id: string; title: string };
  /**
   * ADR 0168 (W2): passende Handlung – nur gesetzt, wenn die Person sie ausführen darf (Einsätze nur Planende,
   * Kosten/Sätze nur Leitung, Rollen nur mit Personendaten-Recht). Die Handlung öffnet den bestehenden Weg mit Vorschau,
   * sie bucht oder ändert nichts selbst.
   */
  action?: 'assign' | 'costs' | 'rates' | 'fillRole';
}

export interface SignalCardDto {
  card: OverviewCard;
  /** vollständige Liste (höchstens 50); `total` = alle Treffer */
  items: SignalItemDto[];
  total: number;
  /** G156-01: Beginn dieses Teils im Gesamtbestand (Seiten zu je 50) */
  offset: number;
}

export interface ProjectSignalsDto {
  /** wirksame Karten in Reihenfolge (eingestellt oder Vorauswahl aus den Werkzeugen) */
  cards: OverviewCard[];
  /** Karten, die die Leitung wählen kann (zugeschaltete Werkzeuge) */
  available: OverviewCard[];
  /** true = von der Leitung eingestellt; false = Vorauswahl */
  configured: boolean;
  /** nur gefüllte Karten, in der Reihenfolge von `cards` */
  signals: SignalCardDto[];
}
